import autobind from 'autobind-decorator';
import * as React from 'react';
import PrimaryButton from 'login-components/Common/Buttons/PrimaryButton';
import './RoleSelector.scss';
import SectionLabel from '../SectionLabel/SectionLabel';

interface RoleSelectorProps {
  submitRole(rolename: string): void;
}

const roles = ['User Admin', 'Loan Officer', 'Loan Processor', 'Super'];

@autobind
class RoleSelector extends React.Component<RoleSelectorProps, {}> {
  handleClick(e) {
    const { submitRole } = this.props;
    const role = e.currentTarget.dataset.role;
    e.preventDefault();
    submitRole(role);
  }

  render() {
    return (
      <form className="RoleSelector">
        <SectionLabel text="Role Login" />
        {roles.map((role, i) => (
          <div className="RoleSelector-buttonWrapper" key={i} data-role={role} onClick={this.handleClick}>
            <PrimaryButton text={role} />
          </div>
        ))}
      </form>
    );
  }
}

export default RoleSelector;
